import { apiError } from '../../utils/errors';
import { getApiBaseUrl } from '../../utils/api-base-url';

import { ThirdPartyType } from '../../types';
export interface ThirdPartyAccessResult {
  trackingId: string;
  urlSlug: string;
  type: ThirdPartyType;
}

export const postThirdPartyAccess = async (
  code: string,
  email: string,
  type: ThirdPartyType,
): Promise<ThirdPartyAccessResult> => {
  const response = await fetch(`${getApiBaseUrl()}/access/third-party`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      code,
      email,
      type,
    }),
  });

  const json = await response.json();

  if (!response.ok) {
    throw apiError(response.status, json?.message || 'Failed to verify code', json?.code);
  }

  return json.data;
};
